export const initialQuarters = {
  quarterBlocks: [...Array(4)].map((_, index) => ({ quarter: index + 1 }))
};
